import {HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http'
import {inject} from '@angular/core'
import {Observable} from 'rxjs'
import {ConfigService} from '../services/config.service'

/**
 * Set this token to true in a request's context
 * to skip adding the 'Authorization' header.
 *
 * @example
 * context: new HttpContext().set(DISABLE_AUTH, true)
 */
export const DISABLE_AUTH = new HttpContextToken<boolean>(() => false)

export const SIGN_TOKEN = new HttpContextToken<string | null>(() => null)
/**
 * Adds 'Authorization: Bearer <token>' header to requests.
 *
 * Skips adding the header if:
 * - No token exists.
 * - The request context has `DISABLE_AUTH` set to true.
 *
 */
export const authInterceptor = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const configService = inject(ConfigService)
  const authToken = configService.accessToken()

  // Skip auth if we don't have a token or explicitly set to not.
  if (!authToken || req.context.get(DISABLE_AUTH)) {
    return next(req)
  }

  // Prefer sign token if requested.
  const token = req.context.get(SIGN_TOKEN) ?? authToken.accessToken

  // Add the token to the request header
  const headers = req.headers
  const authReq = req.clone({
    headers: headers.set('Authorization', `Bearer ${token}`)
  })
  return next(authReq)
}
